<arpio-center-panel>
  <h3 class="panel-title">Link subscription to an existing {{ uiService.productName }} account</h3>
  <ng-container *ngIf="accounts === null; else accountsLoadedBlock">
    <div class="margin-top"><i class="fa-solid fa-spinner fa-spin"></i>Loading existing account list...</div>
  </ng-container>
  <ng-template #accountsLoadedBlock>
    <ng-container *ngIf="accounts.length === 0; else singleAccountBlock">
      <div class="margin-top">
        Sorry, we can't find any existing accounts for you, but we'd be happy to create you a new account.
        <div class="flex-center-row margin-top">
          <div class="spacer"></div>
          <button type="button" class="arpio-button" (click)="newAccountClick()">CREATE NEW ACCOUNT</button>
          <div class="spacer"></div>
        </div>
      </div>
    </ng-container>
    <ng-template #singleAccountBlock>
      <ng-container *ngIf="accounts.length === 1; else multipleAccountsBlock">
        <div class="margin-top">
          We have found the following account that you can link to this subscription:
          <ul id="account-details">
            <li>Account Name: {{ accounts[0].name }}</li>
            <li>Account ID: {{ accounts[0].accountId }}</li>
          </ul>
          <div class="flex-center-row margin-top">
            <div class="spacer"></div>
            <button type="button" class="arpio-button" (click)="linkAccount(accounts[0])">LINK ACCOUNT</button>
            <div class="spacer"></div>
          </div>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #multipleAccountsBlock>
      <div class="margin-top">Select an account to link to this subscription.</div>
      <ul id="many-accounts-list">
        <li *ngFor="let account of accounts">
          <a href (click)="$event.preventDefault(); linkAccount(account)"
            >{{ account.name }} ({{ account.accountId }})</a
          >
        </li>
      </ul>
    </ng-template>
    <div class="margin-top">
      Not seeing the account you expected?
      <a href (click)="$event.preventDefault(); reLogin()">Sign-in as a different user.</a>
    </div>
  </ng-template>
</arpio-center-panel>
